import { NgModule } from '@angular/core';
import { AnimatedShinyTextComponent } from './animated-shiny-text.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        AnimatedShinyTextComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        AnimatedShinyTextComponent
    ]
})
export class NcAnimatedShinyTextModule { }